<template>
  <div>
    <v-text-field
      :value="normalizeYear(value.text || '')"
      label="Footer Text"
      outlined
      dense
      @input="update('text', normalizeYear($event))"
    />
    <div class="mb-2 font-weight-medium">Footer Links</div>
    <v-card v-for="(link, i) in links" :key="i" outlined class="mb-2 pa-3">
      <v-row dense>
        <v-col cols="5">
          <v-text-field
            :value="link.label"
            label="Label"
            outlined
            dense
            @input="updateLink(i, 'label', $event)"
          />
        </v-col>
        <v-col cols="5">
          <v-text-field
            :value="link.url"
            label="URL"
            outlined
            dense
            @input="updateLink(i, 'url', $event)"
          />
        </v-col>
        <v-col cols="2" class="d-flex align-center">
          <v-btn icon small color="error" @click="removeLink(i)">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-btn text small color="primary" @click="addLink">
      <v-icon small left>mdi-plus</v-icon>Add Link
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object, default: () => ({}) },
  },
  mounted() {
    var normalizedText = this.normalizeYear(this.value.text || "");
    if (normalizedText !== (this.value.text || "")) {
      this.update("text", normalizedText);
    }
  },
  computed: {
    links() {
      return this.value.links || [];
    },
  },
  methods: {
    normalizeYear(text) {
      var currentYear = new Date().getFullYear().toString();
      return String(text || "").replace(/\b(19|20)\d{2}\b/g, currentYear);
    },
    update(key, val) {
      this.$emit("input", { ...this.value, [key]: val });
    },
    addLink() {
      this.$emit("input", {
        ...this.value,
        links: [...this.links, { label: "", url: "" }],
      });
    },
    removeLink(i) {
      this.$emit("input", {
        ...this.value,
        links: this.links.filter((_, idx) => idx !== i),
      });
    },
    updateLink(i, key, val) {
      var links = this.links.map((link, idx) =>
        idx === i ? { ...link, [key]: val } : link
      );
      this.$emit("input", { ...this.value, links });
    },
  },
};
</script>
